var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12.999,
    viewBox: "0 0 13 12.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.016)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    d: "M7.932,6.516l4.861-4.861a.712.712,0,0,0,0-1.005L12.366.224a.713.713,0,0,0-1.006,0L6.5,5.084,1.639.224a.712.712,0,0,0-1.005,0L.208.649a.712.712,0,0,0,0,1.005L5.069,6.516.208,11.376a.713.713,0,0,0,0,1.006l.426.426a.712.712,0,0,0,1.005,0L6.5,7.947l4.861,4.861a.705.705,0,0,0,.5.208h0a.705.705,0,0,0,.5-.208l.426-.426a.713.713,0,0,0,0-1.006Z",
    transform: "translate(0 -0.016)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f76ba70fd4fc700ecedc971e42b30c34.svg";
export { ForwardRef as ReactComponent };